import { useEffect, useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { ColapsedReferent } from './collapsedReferent';
import { EditReferent } from './editReferent';
import { getUserRepresentativeSelfcare} from '../../../actions/referent-api';
import * as Loadings from '../../../constants/loadings/referent';
import { LoadingState } from '../../../_common/loadingState';


export const FormReferent = () => {

    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const [isEditing, setIsEditing] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const referent = useSelector(state => state.referent)
    const gender = { male: 2, female: 1 };
    const queryParamsToken = new URLSearchParams(location.search).get("token");
	
    useEffect(() => {
        if (!R.isNil(queryParamsToken)) {
            dispatch(getUserRepresentativeSelfcare(queryParamsToken))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[]);

    if(R.isNil(referent)){
        return "";
    }

    if(R.isNil(referent) || R.isNil(referent.user)){
        //SHOW A LOADING
        if (referent.isLoading.includes(Loadings.FETCHING_USERREPRESENTATIVE)) {
            return (
                <article className="flex-column mb-auto h-100 scroll-default bg-common rounded">
                    <LoadingState />
                </article>
            );
        }
        return "";
    }

    return (
			<form className="flex-column mt-4 mb-auto h-inherit scroll-default">
				{referent.user.createdByRepresentative ? (
					<header className="block mb-auto pr-3">
						<h1 className="h1 text-primary font-weight-bolder mb-2">
							Bienvenue {referent.user.gender === gender.male ? "Mr" : "Mme"} {referent.user.firstName} {referent.user.lastName}.
						</h1>
						<p className="o-80 mb-1">
							Vous allez pouvoir compléter le dossier de votre {referent.user.representedRelation}, {referent.user.representedFirstName} {referent.user.representedLastName}.
						</p>
						<p className="o-60 fs-3">Veuillez confirmer vos informations.</p>
					</header>
				) : (
					<header className="block mb-auto pr-3">
						<h1 className="h1 text-primary font-weight-bolder mb-2">
							Bienvenue {referent.user.gender === gender.male ? "Mr" : "Mme"} {referent.user.firstName} {referent.user.lastName}.
						</h1>
						<p className="o-80 mb-1">
							Votre {referent.user.representedRelation}, {referent.user.representedFirstName} {referent.user.representedLastName}, vous a choisi comme réfèrent dans son dossier.
						</p>
						<p className="o-60 fs-3">Veuillez trouver ci-dessous les informations notées afin que nous vous informions annuellement du suivi du dossier.</p>
					</header>
				)}

				<section className="block mb-auto">
					<div className="container-lg-copy">{isEditing ? <EditReferent data={referent.user} setIsEditing={setIsEditing} token={queryParamsToken} /> : <ColapsedReferent setIsEditing={setIsEditing} data={referent.user} />}</div>
					<p className="d-block fs-2 pr-3 mt-2">
						En cliquant sur "Suivant", vous acceptez les{" "}
						<Link to="/legal/terms" target="_blank" className="btn-link text-info font-weight-bold text-decoration-none">
							Conditions générales d'utilisation et la Politique de protection des données
						</Link>
						.
					</p>
				</section>
				<footer className="block sticky-auto b-auto-0 pt-1 bg-white mt-auto text-left w-100 rounded-inherit">
					<Link to="/index" className={`btn btn-faded px-sm px-md-gutter mr-2 mr-md-3 ${isEditing ? "disabled btn-disabled" : ""}`}>
						Fermer
					</Link>
					<Link to={`/auth/referent/password${location.search}`} className={`btn btn-primary px-sm px-md-gutter mr-3 ${isEditing ? "disabled btn-disabled" : ""}`}>
						Suivant
					</Link>
				</footer>
			</form>
		);
}